export default "__VITE_ASSET__DLO9ueJz__"